import 'css-chunksrc/client/pages/zonesPage/header/styles.scss';export default {
  "header": "_header_2c150_1",
  "title": "_title_2c150_10",
  "button": "_button_2c150_17",
  "profileNavigation": "_profileNavigation_2c150_32"
};